module.exports = __webpack_public_path__ + "static/media/flykube.fe14c3e2.svg";